import React, { useState } from 'react';
import BaseForm from '../../app/components/BaseForm';
import Input from '../../app/components/Input';
import Select from '../../app/components/Select';
import { FiArrowRight, FiPlus, FiEdit } from 'react-icons/fi';


const FormAddAutomations = ({ isOpen, onClose, onSubmit }) => {
  const [form, setForm] = useState({
    name: '',
    description: '',
    trigger: '',
    department: '',
    sequence: '',
    triggerFilter: '',
  });

  const isValid =
    form.name &&
    form.trigger &&
    form.department &&
    form.sequence;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleTriggerSelect = (value) => {
    setForm({ ...form, trigger: value });
  };

  const handleSubmit = () => {
    if (isValid) onSubmit(form);
  };

  const gatilhos = [
    { value: 'card_moved', label: 'Card Movido', icon: <FiArrowRight /> },
    { value: 'new_card', label: 'Novo Card', icon: <FiPlus /> },
    { value: 'card_updated', label: 'Card Atualizado', icon: <FiEdit /> },
  ];

  const filtros = [
    { value: '', label: 'Sem Filtro' },
    { value: 'na_fase', label: 'Na Fase' },
    { value: 'para_fase', label: 'Para a Fase' },
    { value: 'de_fase', label: 'De uma Fase' },
  ];

  const departamentos = [
    { value: 'Fiscal', label: 'Fiscal' },
    { value: 'Contábil', label: 'Contábil' },
    { value: 'DP', label: 'DP' },
    { value: 'Financeiro', label: 'Financeiro' },
    { value: 'Sucesso do Cliente', label: 'Sucesso do Cliente' },
    { value: 'Comercial', label: 'Comercial' },
    { value: 'Recursos Humanos', label: 'Recursos Humanos' },
    { value: 'Legalização', label: 'Legalização' },
    { value: 'Gestão de Riscos', label: 'Gestão de Riscos' },
    { value: 'Gestão para Resultados', label: 'Gestão para Resultados' },
    { value: 'Ordens de Serviços', label: 'Ordens de Serviços' },
  ];

  const sequencias = [
    { value: 'Entrada de Cliente', label: 'Entrada de Cliente' },
    { value: 'Base de Colaboradores', label: 'Base de Colaboradores' },
    { value: 'Legalização', label: 'Legalização' },
    { value: 'Banco de Talentos', label: 'Banco de Talentos' },
    { value: 'Obrigações Acessórias', label: 'Obrigações Acessórias' },
    { value: 'Apuração Fiscal', label: 'Apuração Fiscal' },
    { value: 'Programação de Folha', label: 'Programação de Folha' },
    { value: 'Controle de Erros', label: 'Controle de Erros' },
    { value: 'Vendas GR', label: 'Vendas GR' },
    { value: 'Churn', label: 'Churn' },
  ];

  return (
    <BaseForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Nova Automação"
      isValid={isValid}
      className='max-w-4xl'
    >
      <div className="grid grid-cols-1 gap-4">
        <Input
          id="name"
          name="name"
          label="Nome da Automação"
          value={form.name}
          onChange={handleChange}
          required
        />

        <div className="relative w-full mb-5">
          <textarea
            id="description"
            name="description"
            value={form.description}
            onChange={handleChange}
            placeholder=" "
            className="peer block w-full appearance-none border border-gray-300 rounded-tl-2xl rounded-tr-2xl rounded-br-2xl p-3 min-h-[100px] focus:outline-none focus:ring-1 focus:ring-purple-500/25 focus:border-purple-700 transition-all"
          />
          <label
            htmlFor="description"
            className="absolute left-4 bg-white px-1 transition-all pointer-events-none text-sm text-gray-500 peer-focus:text-purple-700 peer-placeholder-shown:top-3 peer-focus:top-[-0.5rem] peer-focus:translate-y-0"
            style={{ top: form.description ? '-0.5rem' : '3' }}
          >
            Descrição
          </label>
        </div>

        <div className="mb-5">
          <label className="block text-sm font-medium text-gray-700 mb-2">Gatilho</label>
          <div className="grid grid-cols-3 gap-4">
            {gatilhos.map((gatilho) => (
              <div
                key={gatilho.value}
                onClick={() => handleTriggerSelect(gatilho.value)}
                className={`
                  flex flex-col items-center justify-center p-4 border rounded-tl-2xl rounded-tr-2xl rounded-br-2xl cursor-pointer transition-all text-gray-600
                  ${form.trigger === gatilho.value 
                    ? 'border-[#a04ccb] shadow-[0_0_3px_rgba(124,58,237,0.5)]' 
                    : 'border-gray-300'}
                `}
              >
                <div className="flex items-center justify-center w-12 h-12 mb-2">
                  <span className="text-xl text-gray-600">{gatilho.icon}</span>
                </div>
                <span className="text-center text-sm">
                  {gatilho.label}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Select
            id="department"
            name="department"
            label="Departamento"
            value={form.department}
            onChange={handleChange}
            options={departamentos}
            required
          />

          <Select
            id="sequence"
            name="sequence"
            label="Sequência"
            value={form.sequence}
            onChange={handleChange}
            options={sequencias}
            required
          />
        </div>

        <Select
          id="triggerFilter"
          name="triggerFilter"
          label="Filtro do Gatilho"
          value={form.triggerFilter}
          onChange={handleChange}
          options={filtros}
        />
      </div>
    </BaseForm>
  );
};

export default FormAddAutomations;